import { render, staticRenderFns } from "./PersonalInformationView2.vue?vue&type=template&id=02047062&scoped=true&"
import script from "./PersonalInformationView2.vue?vue&type=script&lang=js&"
export * from "./PersonalInformationView2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02047062",
  null
  
)

export default component.exports